import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  updateRecomment,
  loadDetailPost,
} from "../../../../../../redux/modules/postSlice";
import { InputComments } from "./style";

function RecommentTextUpdate({
  post,
  comment,
  recomment,
  setRecommentMorePropsFunc,
  setVisiblePropsFunc,
}) {
  const dispatch = useDispatch();
  const upDateTextareaRef = useRef(null);
  const [recommentText, setRecommentText] = useState("");
  const [recommentAble, setRecommentAble] = useState("black");
  const [upDateFocus, setUpDateFocus] = useState("focus");
  const [upDateCommentLength, setUpDateCommentLength] = useState(0);

  useEffect(() => {
    setRecommentText(recomment.content);
  }, [recomment.content]);

  // 답글 수정후 클릭(수정된 댓글 서버로 전송)
  const onClickCommentUpDateDispatch = useCallback(() => {
    setRecommentMorePropsFunc();
    setVisiblePropsFunc();
    const payload = {
      recommentId: recomment.recommentId,
      content: upDateTextareaRef.current.value,
    };
    dispatch(updateRecomment(payload))
      .unwrap()
      .then((res) => {
        dispatch(loadDetailPost(post.boardId));
      });
  }, [
    setRecommentMorePropsFunc,
    setVisiblePropsFunc,
    recomment.recommentId,
    dispatch,
    post.boardId,
  ]);

  const onChangeUpDateComment = useCallback(
    (e) => {
      setRecommentText(e.target.value);
      setUpDateCommentLength(e.target.value.length);

      // 자동높이조절
      upDateTextareaRef.current.style.height = "auto";
      upDateTextareaRef.current.style.height = `${upDateTextareaRef.current.scrollHeight}px`;
    },
    [upDateCommentLength],
  );

  return (
    <InputComments>
      <textarea
        ref={upDateTextareaRef}
        className={upDateFocus}
        type="text"
        rows="1"
        maxLength="80"
        placeholder="댓글을 입력해 주세요"
        value={recommentText}
        autoFocus
        onFocus={() => setUpDateFocus("focus")}
        onBlur={() => setUpDateFocus("blur")}
        onChange={(e) => onChangeUpDateComment(e)}
      />
      {(upDateFocus === "focus" || upDateCommentLength > 0) && (
        <div
          className="textareaAside"
          onClick={() => {
            upDateTextareaRef.current.focus();
          }}
        >
          <div>{upDateCommentLength}/80</div>
          <button
            className={upDateCommentLength > 0 ? "orange" : "black"}
            onClick={onClickCommentUpDateDispatch}
          >
            등록
          </button>
        </div>
      )}
    </InputComments>
  );
}

export default RecommentTextUpdate;
